export const SHARED_ENV = {
  version: '6.9.13',
  uuid: '9A8b7C6d5E4f3G2h1i0',
  minPasswordLength: 8,
  maxPasswordLength: 25,
};
